export interface IBreadcrumbsNav {
  level1?: string;
  level1Href?: string;
  level2?: string;
  level2Href?: string;
  level3?: string;
  level3Href?: string;
  current: string;
}

export type BreadcrumbLevel = "level1" | "level2" | "level3";

export function getBreadcrumbHref(
  breadcrumbsNav: IBreadcrumbsNav,
  level: BreadcrumbLevel,
): string | undefined {
  if (level === "level1") {
    return (
      breadcrumbsNav.level1Href ?? (breadcrumbsNav.level1 ? `/${breadcrumbsNav.level1}` : undefined)
    );
  }

  if (level === "level2") {
    return breadcrumbsNav.level2Href;
  }

  return breadcrumbsNav.level3Href;
}
